// /**
//  * Four Column Carousel
//  */

import 'owl.carousel/dist/owl.carousel.min.js';

import $ from 'jquery';

const fourColCarousel = {
  prevIcon: '<span class="carousel-control-prev-icon" aria-hidden="true"></span>',
  nextIcon: '<span class="carousel-control-next-icon" aria-hidden="true"></span>',
  initFourColCarousel: () => {
    // Make whole card clickable
    const carousel = $('.sca-four-col-carousel');
    const cards = carousel.find('.four-col-card');
    cards.each(function () {
      const $this = $(this);

      $this.on('click', function (e) {
        if ($this.find($(e.target).closest('a')[0]).length === 0) {
          // Not on the anchor, do it
          e.preventDefault();
          $this.find('a')[0].click();
        }
      });
    });

    fourColCarousel.startCarousel();
  },
  startCarousel: () => {
    $('.sca-four-col-carousel-wrapper').each(function () {
      $(this)
        .find('>:first-child')
        .owlCarousel({
          smartSpeed: 300,
          direction: 'next',
          slideTransition: 'linear',
          loop: false,
          slideBy: 1,
          margin: 12,
          stagePadding: 0,
          nav: true,
          dots: true,
          dotsEach: 1,
          autoWidth: false,
          lazyload: false,
          items: 4,
          navText: [
            $(this).find('.carousel-control-prev-icon'),
            $(this).find('.carousel-control-next-icon'),
          ],
          responsive: {
            0: {
              items: 2,
              autoWidth: true,
            },
            500: {
              items: 2,
              autoWidth: true,
            },
            575: {
              items: 3,
              autoWidth: true,
            },
            600: {
              items: 3,
              autoWidth: true,
            },
            924: {
              autoWidth: false,
            },
            1200: {
              autoWidth: false,
            },
            1400: {
              slideBy: 1,
              dots: true,
            },
            1600: {
              autoWidth: false,
            },
          },
          onInitialized() {
            $('.four-col-carousel').find('.owl-item').attr('aria-current', 'false');
            $('.four-col-carousel').find('.owl-item.active').attr('aria-current', 'true');
            // Add aria attribute to dots
            $('.four-col-carousel')
              .find('.owl-dot')
              .each(function (index) {
                //Add one to index so it starts from 1
                $(this).attr('aria-label', `slide ${index + 1}`);
              });
            $('.four-col-carousel').attr('tabindex', '0');
            // Add aria attributes to buttons
            $('.four-col-carousel').find('.owl-prev').attr('aria-label', 'previous');
            $('.four-col-carousel').find('.owl-prev').attr('role', 'button');
            $('.four-col-carousel').find('.owl-next').attr('aria-label', 'next');
            $('.four-col-carousel').find('.owl-next').attr('role', 'button');

            // Remove controls
            const nav = $('.sca-four-col-carousel').find('.owl-nav');
            const dots = $('.sca-four-col-carousel').find('.owl-dots');
            const items = $('.sca-four-col-carousel').find('.owl-item');

            if (items.length <= 1) {
              nav.addClass('hide-small');
              dots.addClass('hide-small');
            } else if (items.length <= 3) {
              nav.addClass('hide-large');
              dots.addClass('hide-large');
            }

            // Make entire tile clickable
            items.on('click', (e) => {
              window.location = e.currentTarget.querySelector('a').href;
            });
          },
        });
    });
  },
};

export default fourColCarousel;
